// components/Chat/index.jsx
import { Routes, Route } from 'react-router-dom';
import ChatRoomList from './ChatRoomList';     // ✅ 채팅방 목록
import ChatLoading from './ChatLoading';       // ✅ 입장/비번 처리

const ChatRoutes = () => {
    return (
        <Routes>
            <Route index element={<ChatRoomList />} />
            <Route path="category/:categoryId" element={<ChatLoading />} />
        </Routes>
    );
};

export default ChatRoutes;